export const data = [
	{
		title: 'Unsere Orchesterjugend',
		description:
			'Die Zukunft des Orchesters!',
		image: './assets/CarouselBilder/UnsereOrchesterjugend.JPG',
	},
	{
		title: 'Ausflug ins Kattegat-Center ',
		description: 'Ausflüge und Probewochenenden!',
		image: './assets/CarouselBilder/AusflugInsKattegat-Center.JPG',
	},
	{
		title: 'Musik und Proben',
		description: 'Üben, üben, üben!',
		image: './assets/CarouselBilder/GeigeUndNoten.JPG',
	},
	{
		title: 'Jubiläumsfest Hirrlingen',
		description: 'Auftritte zu jedem Anlass!',
		image: './assets/CarouselBilder/Hirrlingen2.JPG',
	},
	{
		title: 'Lernen zum Erfolg',
		description: 'Persönliche Betreung!',
		image: './assets/CarouselBilder/Hirrlingen1.JPG'
	}
];

export const sliderSettings = {
	arrows: false,
	slidesToShow: 3,
	focusOnselect: false,
	accessability: false,
	responsive: [
		{
			breakpoint: 1280,
			settings: {
				slidesToShow: 2,
			},
		},

		{
			breakpoint: 900,
			settings: {
				slidesToShow: 1,
			},
		},
	],
};